import { memo, useMemo } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import GameBar from 'components/pages/Analytics/GameBars/GameBar/GameBar';

import styles from './GameBars.module.scss';

const GameBars = ({ type = 'vertical', games }) => {
  const isVertical = useMemo(() => type === 'vertical', [type]);

  const barsJSX = useMemo(
    () =>
      games?.map(
        ({ gameName, gameCode, icon, percentage, backgroundColor }, index) => (
          <GameBar
            key={gameName}
            type={type}
            gameName={gameName}
            gameCode={gameCode}
            icon={icon}
            percentage={percentage}
            backgroundColor={backgroundColor}
            withCrown={isVertical && !index}
            withTooltip={isVertical}
          />
        ),
      ),
    [games, type, isVertical],
  );

  return (
    <div className={classNames(styles.wrapper, styles[type])}>{barsJSX}</div>
  );
};

GameBars.propTypes = {
  type: PropTypes.oneOf(['horizontal', 'vertical']),
  games: PropTypes.arrayOf(
    PropTypes.shape({
      gameName: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      percentage: PropTypes.number.isRequired,
      backgroundColor: PropTypes.string,
    }),
  ).isRequired,
};

export default memo(GameBars);
